<template>
  <div>
    <div class="app-container">
      <Block class="my-block-item">
        <router-link :to="{ name: 'TermsAndConditions' }">
          <md-cell-item :title="$t('file_draft_syarat_layanan')" arrow />
        </router-link>
        <router-link :to="{ name: 'PrivacyPolicy' }">
          <md-cell-item :title="$t('Privacy Policy')" arrow />
        </router-link>
      </Block>
      <!-- <div class="version">
        {{ $t('version') }}
      </div> -->
    </div>
  </div>
</template>

<script>
// 关于我们
import Block from '@/components/Block'
import { CellItem } from 'mand-mobile'
export default {
  name: 'MeAboutFlashPay',
  components: {
    Block,
    [CellItem.name]: CellItem
  },
  data () {
    return {}
  },
  created () {},
  mounted () {},
  methods: {}
}
</script>

<style lang='scss' scoped>
/* stylelint-disable selector-pseudo-element-no-unknown */

.my-block-item {
  ::v-deep .flash-block__content {
    border-radius: 32px;

    .flash-block_body {
      padding: 0 40px 0 24px;
    }

    .md-cell-item-body {
      padding-top: 46px;
      padding-bottom: 46px;
    }

    .md-cell-item-left {
      margin-right: 28px;
    }
  }
}

.version {
  width: 100%;
  height: 28px;
  font-size: 28px;
  font-weight: 400;
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
  line-height: 28px;
  position: fixed;
  bottom: 58px;
  left: 0;
}
/* stylelint-enable */
</style>
